var map = {
	"./Header": 1004,
	"./Header.tsx": 1004,
	"./Hello": 1027,
	"./Hello.js": 1027,
	"./collections/approveModal": 928,
	"./collections/approveModal.tsx": 928,
	"./collections/comment_like": 1201,
	"./collections/comment_like.tsx": 1201,
	"./collections/create": 1202,
	"./collections/create.tsx": 1202,
	"./collections/like": 1203,
	"./collections/like.tsx": 1203,
	"./common/header": 1204,
	"./common/header.tsx": 1204,
	"./common/modal": 1001,
	"./common/modal.tsx": 1001,
	"./myEthWallet/connect": 1205,
	"./myEthWallet/connect.tsx": 1205,
	"./walletConnect/walletConnect": 1206,
	"./walletConnect/walletConnect.tsx": 1206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1214;